let products = {};

function createNotice() {
  const cart_text = window.cart_name;
  const panier_page_url = window.panier_page_url;

  document.body.insertAdjacentHTML(
    "beforeend",
    `
      <div class="cart__notice">
        <table>
          <tbody class="cart__notice__items">
          </tbody>
        </table>
        <div>
        <a href="${panier_page_url}" class="validate__cart">
         ${cart_text}
        </a>
      </div>
    `
  );
}

function updateNotice() {
  const cart = document.querySelector(".cart__notice");
  let items = document.querySelector(".cart__notice__items");

  if (!cart || !items) return;

  items.innerHTML = "";
  cart.classList.remove("animate_cart");
  setTimeout(() => {
    cart.classList.add("animate_cart");
  }, 50);

  if (Object.keys(products).length === 0) {
    cart.style.visibility = "hidden";
  } else {
    cart.style.visibility = "visible";

    Object.entries(products).map(([slug, opt]) => {
      items.insertAdjacentHTML(
        "beforeend",
        `
        <tr class="cart__item">
          <td>
            <a href="${opt.url}">
              <b>${opt.title}</b>
              ${opt.subtitle ? "</br>" + opt.subtitle : ""}
            </a>
          </td>
          <td>
            ${opt.count}
          </td>
          <td>
          <button type="button" class="cart_button remove__product" data-productslug="${slug}">
            <svg class="svg-icon" viewBox="0 0 20 20">
              <path d="M15.898,4.045c-0.271-0.272-0.713-0.272-0.986,0l-4.71,4.711L5.493,4.045c-0.272-0.272-0.714-0.272-0.986,0s-0.272,0.714,0,0.986l4.709,4.711l-4.71,4.711c-0.272,0.271-0.272,0.713,0,0.986c0.136,0.136,0.314,0.203,0.492,0.203c0.179,0,0.357-0.067,0.493-0.203l4.711-4.711l4.71,4.711c0.137,0.136,0.314,0.203,0.494,0.203c0.178,0,0.355-0.067,0.492-0.203c0.273-0.273,0.273-0.715,0-0.986l-4.711-4.711l4.711-4.711C16.172,4.759,16.172,4.317,15.898,4.045z"></path>
            </svg>
          </button>
          </td>
        </tr>
      `
      );
    });

    items.querySelectorAll("button.remove__product").forEach((btn) => {
      btn.addEventListener("click", function () {
        const slug = btn.dataset.productslug;
        removeProduct({ slug });
      });
    });
  }
}

function updateStorage() {
  localStorage.setItem("products", JSON.stringify(products));
}

function addProduct(evt) {
  const slug = evt.detail.product.slug;
  const title = evt.detail.product.title;
  const subtitle = evt.detail.product.subtitle;
  const price = evt.detail.product.price;

  if (!products.hasOwnProperty(slug))
    products[slug] = {
      count: 0,
      price,
      title,
      subtitle,
      url: location.href,
    };

  products[slug].count = products[slug].count + 1;

  updateNotice();
  updateStorage();
}
function removeProduct({ slug }) {
  delete products[slug];
  updateNotice();
  updateStorage();
}

export default ({} = {}) => {
  console.log("init cart");

  if (localStorage.getItem("products")) {
    products = JSON.parse(localStorage.getItem("products"));
  }
  createNotice();

  setTimeout(() => {
    updateNotice();
  }, 150);

  window.removeEventListener("addProduct", addProduct);
  window.addEventListener("addProduct", addProduct);

  return {};
};
